<template>
    <div>
        <div class="bigText">请拍摄本人正面照进行实名认证</div>
        <div style="margin-top: 45px;">
            <img class="bigImg" src="./images/btn_zhaopian_nor@2x.png" alt="" srcset="">
            <div style="margin: 5px auto;text-align: center;">（示例照片）</div>
        </div>
        <div style="margin: 20px auto;width: 85%;">
            <el-checkbox style="display: block;" v-model="checked" @change="tipChange">
                <span style="color: #606266;">我已阅读《人脸特征保护协议》，并同意本校拍摄</span>
            </el-checkbox>
            <div style="padding-left: 23px;color:#606266;font-size: 14px">我的人脸影像用于实名认证</div>
            <div style="color: red;" v-show="tip">请选中....</div>
        </div>
        <el-button style="display: block;" class="lwork" type="primary" @click="contact">开启实名拍照</el-button>
    </div>
</template>

<script>
export default {
    data(){
        return{
            checked:false,
            tip:false,
        }
    },
    methods:{
        contact(){
            this.tip = false
            if (this.checked == false) {
                this.tip = true
            } else{

            }
        },
        tipChange(){
            if (this.checked == false) {
                // this.tip = true
            } else{
                this.tip = false
            }
        }
    },
}
</script>

<style lang="less" scoped>
.bigText{
    color: #333333;
    text-align: center;
    font-size: 20px;
    margin: 18px auto;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
    color:#606266
}
.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    margin: auto;
}
.el-button+.el-button {
    margin: auto;
}
.bigImg{
    display: block;
    width: 61%;
    height: 265px;
    margin: 15px auto;
}
.lwork{
    width: 80%;
    background-color: #00706E;
    height: 35px;
    font-size: 20px;
    color: #fff;
    margin: 20px auto;
    border-radius: 35px;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/IdentitAuthentication/realName.vue